import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import Raven from 'raven-js';
import ReactGA from 'react-ga';
import App from './containers/app/app';

if (process.env.REACT_APP_ENV !== 'development') {
  Raven.config(process.env.REACT_APP_SENTRY_URL, {
    environment: process.env.REACT_APP_ENV
  }).install();
}

// create history
const history = createHistory();

if (process.env.REACT_APP_ENV === 'production') {
  // setup analytics
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN);

  // initial tracking
  ReactGA.set({ page: window.location.pathname, anonymizeIp: true });
  ReactGA.pageview(window.location.pathname);

  // further tracking
  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}




render(
  <Router history={history}>
    <App/>
  </Router>, document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js